<template>
  <div class="detail-padding">
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">My Voting List</div>
      </div>
      <div class="spaceLeft search-form">
        <!-- <div class="sapceLeft search-item">
          <el-checkbox v-model="searchParams.status" @change="getList">Not extracted UNIT</el-checkbox>
        </div> -->
        <!-- <search-select @valChange="valChange($event, 'proposalStatus')" label="Proposal results" :options="typeOptions" :default-value="searchParams.proposalStatus" /> -->
        <div class="sapceLeft search-item">
          <el-input v-model="searchParams.proposalId" placeholder="No..." suffix-icon="el-icon-search" @change="getList" />
        </div>
      </div>
    </div>

    <div class="common-card is-border">
      <div class="common-card-main">
        <el-table class="common-table" :data="tableList" v-loading="loading">
          <el-table-column label="Proposal No.">
            <template slot-scope="{ row }">
              No.{{ row.proposal.id }}
            </template>
          </el-table-column>
          <el-table-column prop="account" label="Proposer">
            <template slot-scope="{ row }">
              <account :value="row.proposal.proposer" />
            </template>
          </el-table-column>
          <el-table-column prop="title" label="Title">
            <template slot-scope="{ row }">
              {{ row.proposal.title }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="Status">
            <template slot-scope="{ row }">
              <vote-status-td-comp :status.sync="row.proposal.status" />
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="My Vote">
            <template slot-scope="{ row }">
              <big-number :number="row.weight" />
              <span class="td-word-sm">UNIT</span>
            </template>
          </el-table-column>
          <el-table-column label="Vote Extraction Status">
            <template slot-scope="{ row }">
              <span class="status" v-if="[2,3,6,7,8].includes(row.proposal.status) && row.status == 0"  @click="handleExtract(row)" >
                <img src="@/assets/image/governance/icon8.png" alt="">Not extracted
                <img src="@/assets/image/governance/icon9.png" />
              </span>
              <span class="status" v-else-if="row.status == 1" >
                <img src="@/assets/image/governance/icon10.png" alt="">
                Extracted
              </span>
              <span class="status" v-else>
                --
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="Operation">
            <template slot-scope="{ row }">
              <!-- <el-button type="primary" v-if="row.proposal.status === 4 && row.status == 0" @click="handleExtract(row)">Extract UNIT</el-button> -->
              <el-button type="primary" @click="toDetail(row)">Details</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total.sync="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
          @pagination="getList()" />

      </div>
    </div>
    <extractDialog ref="extractDialog" @success="refresh" />
  </div>
</template>

<script>
import { mylist } from "@/api/dao.js"
import extractDialog from "./extractDialog.vue"
import voteStatusTdComp from "@/views/governance/components/voteStatusTdComp.vue"
export default {
  components: { extractDialog, voteStatusTdComp },
  data() {
    return {
      loading: false,
      searchParams: {
        status: false,
        number: undefined,
        proposalStatus: "0",
        proposalId: undefined,
      },
      statusArray: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [],
      typeOptions: this.$store.getters.proposalStatus,
      threshold: 0
    };
  },
  computed: {},
  methods: {
    init() {
      if (this.getToken()) {
        this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
        this.getList();
      } else {
        this.$message.warning("You must sign in to the wallet to view this page!");
      }
    },
    valChange(data, prop) {
      this.searchParams[prop] = data.value;
      if (prop === 'proposalStatus') {
        if (data.value === '1') {
          this.statusArr = [0, 1]
        } else if (data.value === '2') {
          this.statusArr = [4, 5, 7, 8]
        } else if (data.value === '3') {
          this.statusArr = [2, 3, 6]
        } else {
          this.statusArr = [0, 1, 2, 3, 4, 5, 6, 7, 8]
        }
      }
      this.getList();
    },
    getList() {
      if (!this.$store.getters.metaMaskObj.account) {
        return;
      }

      this.loading = true;
      let params = {
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        voter: this.$store.getters.metaMaskObj.account,
        // number: this.searchParams.number,
        // status: this.searchParams.status ? 1 : undefined,
        // proposalStatus: this.statusArr,
        id: this.searchParams.proposalId,
        
      }
      mylist(params).then(res => {
        let list = res.result && res.result.data || [];
        let reqArr = []
        list.forEach(item => {
          reqArr.push(this.getProposalThreshold(item))
        })
        Promise.all(reqArr).then(() => {
          list.forEach(item => {
            if(item.proposal.curBlock >= item.proposal.endBlock) {
              if (item.proposal.totalWeight >= +item.proposal.threshold) {
                 item.proposal.status = 4;
              }
              else {
                item.proposal.status = 3;
              }
            }
            else{
              item.proposal.status = 1;
            }
          })
          this.tableList = list;
        })
        this.queryParams.total = res.result.total || 0;
        this.loading = false;
      }).catch(e => {
        this.loading = false;
      })
    },
    async getProposalThreshold(row) {
      try {
        row.proposal.curBlock = await web3.eth.getBlockNumber()
        row.proposal.threshold = await this.contractDao.methods.quorum(row.proposal.endBlock).call({ from: this.$store.getters.metaMaskObj.account })
        return row
      } catch (e) {
        console.log(e);
        row.proposal.threshold = 0
        return row
      }
    },
    showBtn(row) {
      let now = new Date().getTime();
      let over = row.over * 1000;
      let isOneDay = false;
      // if((now - over) >= 1000 * 60 * 60 *24){
      //   isOneDay = true;
      // }
      isOneDay = true; //测试专用
      if (row.extractStatus == 1 && isOneDay) {
        return "toExtract";
      }
      else if (row.extractStatus == 2) {
        return "extracted";
      }
      else {
        return "null"
      }
    },
    handleExtract(data) {
      this.$refs.extractDialog.open({
        row: data,
        threshold: 0
      })
    },
    toDetail(row) {
      this.$router.push({
        path: "/Governance/vote/Detail",
        query: {
          fromPath: "/Governance/vote",
          proposalId: row.proposalId
        }
      });
    },
    refresh() {
      this.getList();
    }
  },
  created() {
    this.init();
    // this.getThreshold();
  }
};
</script>
<style scoped lang="scss">
.blue-btn, .el-button--primary{
  background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
}
.td-word-sm{
  font-size: 0.12rem;
}
.status {
  width: 1.12rem;
  height: 0.28rem;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 0.14rem;
  border-radius: 0.04rem;
  line-height: 0.28rem;
  white-space: nowrap;
  cursor: pointer;
  img {
    width: 0.2rem;
    margin-right: 0.06rem;
    margin-left: 0.1rem;
  }
}
</style>
